import { useState } from 'react';

export default function TechnologySection() {
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      title: 'RAG (Yapay Zeka Destekli Doğrulama)',
      description: 'Sadece okumaz, veriyi firmanızın geçmiş verileriyle ve kurallarıyla doğrular.',
      icon: 'ri-brain-2-line',
    },
    {
      title: 'Tam Otomasyon',
      description: 'Manuel veri girişini %100 otomatize ederek zaman kaybını önler.',
      icon: 'ri-robot-2-line',
    },
    {
      title: 'Circuit Breaker Güvenliği',
      description: 'Hatalı verinin veritabanınıza sızmasını fiziksel olarak engeller.',
      icon: 'ri-shield-flash-line',
    },
  ];

  return (
    <section id="teknoloji" className="bg-gradient-to-b from-white via-[#F9FAFB] to-white py-40 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#2563EB]/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#0EA5E9]/5 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left Visual */}
          <div className="relative notion-fade-in">
            <div className="rounded-[32px] overflow-hidden shadow-2xl border border-white/20">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20glowing%20blue%20neural%20network%20connecting%20floating%20document%20icons%20and%20data%20nodes%2C%20futuristic%20artificial%20intelligence%20visualization%20with%20circuit%20patterns%20and%20light%20beams%2C%20royal%20blue%20and%20white%20color%20scheme%2C%20clean%20professional%20tech%20illustration%20showing%20document%20processing%20and%20data%20validation%2C%20geometric%20shapes%20and%20digital%20connections%2C%20modern%20industrial%20technology%20aesthetic%2C%20high-tech%20corporate%20style&width=800&height=600&seq=docai-tech-visual-001&orientation=landscape"
                alt="DocAI Technology Architecture"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Glow Effect */}
            <div className="absolute -inset-4 bg-gradient-to-r from-[#2563EB]/10 to-[#0EA5E9]/10 rounded-[40px] -z-10 blur-3xl"></div>
          </div>

          {/* Right Content */}
          <div className="lg:pl-20">
            {/* Accent Line */}
            <div className="w-20 h-1 bg-gradient-to-r from-[#2563EB] to-[#0EA5E9] mb-6 notion-fade-in"></div>

            {/* Section Title */}
            <h2 className="notion-fade-in text-5xl font-extrabold text-[#1E293B] mb-14" style={{ fontFamily: 'Playfair Display, serif', animationDelay: '0.1s' }}>
              Yapay Zeka ile Güçlendirildi
            </h2>

            {/* Feature List */}
            <div className="space-y-6">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  onClick={() => setActiveFeature(index)}
                  className={`notion-card p-6 cursor-pointer group ${
                    activeFeature === index
                      ? 'bg-gradient-to-r from-[#2563EB]/20 to-[#0EA5E9]/20 border-2 border-[#2563EB] shadow-lg'
                      : 'hover:border-[#2563EB]/30'
                  }`}
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="flex gap-4">
                    {/* Icon Circle */}
                    <div className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center font-bold text-white smooth-transition group-hover:scale-110 ${
                      activeFeature === index
                        ? 'bg-gradient-to-br from-[#2563EB] to-[#1d4ed8]'
                        : 'bg-[#2563EB]'
                    }`}>
                      <i className={`${feature.icon} text-xl`}></i>
                    </div>

                    {/* Text Content */}
                    <div className="flex-1">
                      <h3 className="text-lg font-bold text-[#1E293B] mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-[15px] text-[#475569]">
                        {feature.description}
                      </p>
                    </div>

                    {/* Arrow */}
                    <div className="opacity-0 group-hover:opacity-100 smooth-transition">
                      <i className="ri-arrow-right-line text-[#2563EB]"></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
